import { useEffect, useState } from 'react'
import useSWR, { SWRResponse } from 'swr'
import axiosInstance from '../../../../../utils/axiosInstance'
import { hasPermission } from '../../../../../utils/tools'
import { useSelector } from '../../../../../store/store'

export function useEditOrderData() {
  const [assignees, setAssignees] = useState([{ firstName: '', lastName: '', id: '' }])
  const [customers, setCustomers] = useState([
    { name: '', id: '', emails: null as null | string[] },
  ])

  const { permissions, userInfo } = useSelector((state) => state.user)
  const permission = hasPermission(permissions?.orderDetailsFields)

  const isCustomer =
    userInfo?.role &&
    ['externalDirectCustomer', 'externalPartnerCustomer', 'externalReseller'].includes(
      userInfo.role
    )

  const canFetchAssignees = !isCustomer

  const { data: fetchedAssignees, isLoading: loadingAssignees }: SWRResponse = useSWR(
    canFetchAssignees ? '/app-users?internalUsers=true' : null,
    axiosInstance
  )
  const { data: fetchedCustomers, isLoading: loadingCustomerNames }: SWRResponse = useSWR(
    '/customers',
    axiosInstance
  )
  const { data: fetchedCampaigns, isLoading: loadingCampaigns }: SWRResponse = useSWR(
    '/campaignIdsAndNames',
    axiosInstance
  )
  const { data: fetchedOriginalMetaCampaigns }: SWRResponse = useSWR(
    '/original-meta-campaigns-ids-and-names',
    axiosInstance
  )
  const { data: fetchedTiktokCampaigns, isLoading: loadingTiktokCampaigns }: SWRResponse = useSWR(
    '/tiktok-campaign-ids-and-names',
    axiosInstance
  )
  const { data: fetchedGoogleCampaigns, isLoading: loadingGoogleCampaigns }: SWRResponse = useSWR(
    '/google-campaign-ids-and-names',
    axiosInstance
  )
  const { data: fetchedJobs, isLoading: loadingJobs }: SWRResponse = useSWR(
    '/jobs?limit=10000',
    axiosInstance
  )

  const campaigns = fetchedCampaigns?.data.campaigns
  const originalMetaCampaigns = fetchedOriginalMetaCampaigns?.data.campaigns
  const tiktokCampaigns = fetchedTiktokCampaigns?.data.campaigns
  const googleCampaigns = fetchedGoogleCampaigns?.data.campaigns
  const jobs = fetchedJobs?.data.jobs

  useEffect(() => {
    if (fetchedAssignees?.data?.appUsers) setAssignees(fetchedAssignees.data.appUsers)
    if (fetchedCustomers?.data?.customers) setCustomers(fetchedCustomers.data.customers)
  }, [fetchedAssignees, fetchedCustomers])

  return {
    assignees,
    customers,
    campaigns,
    originalMetaCampaigns,
    tiktokCampaigns,
    googleCampaigns,
    jobs,
    loadingAssignees,
    loadingCustomerNames,
    loadingCampaigns,
    loadingTiktokCampaigns,
    loadingGoogleCampaigns,
    loadingJobs,
    permission,
    isCustomer,
  }
}
